import { instance } from "api/apiBase";
import {
  PrescreeningCreditScore,
  PrescreeningGrossMonthlyIncome,
  PrescreeningQuestionRecord
} from "shared/types";
import { Lead } from "views/leads-id/types";
import { User } from "views/settings-users/types";

interface PrescreeningQuestionAnswers extends PrescreeningQuestionRecord {
  answers: { name: string; answer: string }[];
}

export type PrescreeningStatus = "in_progress" | "submitted" | null;

export interface LeadPrescreeningsResponse {
  credit_score: PrescreeningCreditScore | null;
  income?: PrescreeningGrossMonthlyIncome;
  question_answers?: PrescreeningQuestionAnswers;
  status: PrescreeningStatus;
}

export const leadApi = {
  getAssignees: async (): Promise<User[]> => {
    const { data } = await instance.get<User[]>("/portal/v1/leads/assignees");
    return data;
  },

  assignLead: async ({
    lead_id,
    partner_user_id
  }: {
    lead_id: number;
    partner_user_id: number | null;
  }): Promise<Lead> => {
    return instance.put(`/portal/v1/leads/${lead_id}`, {
      partner_user_id
    });
  },

  getPrescreenings: async (
    leadId: string
  ): Promise<LeadPrescreeningsResponse> => {
    const { data } = await instance.get<LeadPrescreeningsResponse>(
      `/portal/v1/leads/${leadId}/prescreenings`
    );
    return data;
  },

  bulkAssignLeads: async ({
    lead_ids,
    partner_user_id
  }: {
    lead_ids: number[];
    partner_user_id: number | null;
  }): Promise<Lead> => {
    return instance.post("/portal/v1/leads/bulk_assign", {
      lead_ids,
      partner_user_id
    });
  }
};
